// libraries
import React from 'react'
import clsx from 'clsx'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils'

// svg
import { Check } from '/react4xp/components/Svg/Ux/Ux'

interface CheckboxProps {
    id?: string
    name?: string
    label?: string
    required?: boolean
    disabled?: boolean
    checked?: boolean
    defaultChecked?: boolean
    children?: React.ReactNode
    className?: string
    helperText?: string
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function Checkbox({
    id,
    name,
    label,
    required,
    disabled,
    checked,
    defaultChecked,
    children,
    className,
    helperText,
    onChange
}: CheckboxProps) {

    return (
        <div className={clsx(
            'form-line',
            className
        )}>

            {label && (
                <p className='text-md label-checkbox'>
                    {label}
                </p>
            )}

            <label className={clsx('form-line__checkbox-wrapper')} htmlFor={id || null}>

                <input
                    id={id}
                    name={name || null}
                    type='checkbox'
                    defaultChecked={defaultChecked}
                    checked={checked}
                    disabled={disabled || false}
                    onChange={onChange}
                    required={required || false}
                />

                <span className='form-line__checkbox-wrapper__checkbox'>
                    <Check />
                </span>

                <span className='form-line__checkbox-wrapper__text'>

                    <span className='text-md checkbox-text'>
                        {children}
                    </span>

                    {isNonWhitespaceString(helperText) && (
                        <span
                            className='form-line__help-text text-sm'
                            dangerouslySetInnerHTML={{ __html: helperText }}
                            suppressHydrationWarning
                        />
                    )}

                </span>

            </label>

        </div>
    )
}